<script lang="ts" setup>
import DealzoneLogo from '~/assets/images/Dealzone-logo.svg'
import DealzoneLogoInactive from '~/assets/images/Dealzone-logo-inactive.svg'
import QuotesLogo from 'assets/images/quotes-logo.svg'
import QuotesLogoInactive from '~/assets/images/Quotes-logo-inactive.svg'
import { useLang } from '~/composables/useLang'
import LayoutEnum from '~/enums/LayoutEnum'
import { Routes } from '~/enums/Routes'
import getLocalizedRoute from '~/utils/getLocalizedRoute'
import CountriesEnum from '~/enums/CountriesEnum'
import getDefaultCountryId from '~/utils/countries/getDefaultCountryId'

const { type } = defineProps<{ type?: LayoutEnum.Market | LayoutEnum.Quote }>()

const { t } = useLang()

const dealzoneDefaultLogo = computed(() => (type === LayoutEnum.Market ? DealzoneLogo : DealzoneLogoInactive))
const quotesDefaultLogo = computed(() => (type === LayoutEnum.Quote ? QuotesLogo : QuotesLogoInactive))

const dealzoneLogo = ref<string>(dealzoneDefaultLogo.value)
const quotesLogo = ref<string>(quotesDefaultLogo.value)

const dealzoneTitle = computed(() => t('nav.dealzone'))
const quotesTitle = computed(() => t('nav.quotes'))
</script>

<template>
  <div class="header-nav">
    <div class="navbar">
      <nav class="nav flex gap-[10px] w-max" role="menubar">
        <NuxtLink
          :to="getLocalizedRoute(Routes.Market)"
          class="nav-item dealzone"
          :class="{ active: type === LayoutEnum.Market }"
          @mouseenter="dealzoneLogo = DealzoneLogo"
          @mouseleave="dealzoneLogo = dealzoneDefaultLogo">
          <img :src="dealzoneLogo" :alt="dealzoneTitle" />
          {{ dealzoneTitle }}
        </NuxtLink>

        <NuxtLink
          :to="getLocalizedRoute(Routes.Quotes)"
          class="nav-item quote"
          :class="{ active: type === LayoutEnum.Quote }"
          @mouseenter="quotesLogo = QuotesLogo"
          @mouseleave="quotesLogo = quotesDefaultLogo">
          <img :src="quotesLogo" :alt="quotesTitle" />
          {{ quotesTitle }}
        </NuxtLink>
      </nav>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.header-nav {
  .navbar {
    background-color: theme('colors.white');
    color: theme('colors.gray6');
    padding: 0;
    box-shadow: none;
    margin-left: 26px;
    border: 0;

    .nav {
      flex-wrap: nowrap;

      .nav-item {
        font-size: 0.875rem;
        display: flex;
        align-items: center;
        gap: 8px;
        max-width: 155px;
        padding: 0.5rem;
        color: theme('colors.black');
        font-weight: 500;
        word-break: break-word;
        border-radius: theme('vars.borderRadiusLight');

        > img {
          height: 36px;
          width: 36px;
          border-radius: 6px;
        }

        &.dealzone.router-link-active,
        &.dealzone.active {
          @apply !text-white bg-purple;

          > img {
            @apply bg-white;
          }

          &:hover {
            @apply bg-purple;
          }
        }

        &.quote.router-link-active,
        &.quote.active {
          @apply bg-quoteYellow;

          > img {
            @apply bg-white;
          }

          &:hover {
            @apply bg-quoteYellow;
          }
        }

        &:hover {
          @apply bg-neutral8 dark:bg-dmGray2;
        }
      }
    }
  }
}
</style>
